import { render, staticRenderFns } from "./AboutApp.vue?vue&type=template&id=0a12c026&scoped=true&"
import script from "./AboutApp.vue?vue&type=script&lang=js&"
export * from "./AboutApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a12c026",
  null
  
)

export default component.exports